import React from 'react';

import * as styles from './UnsupportedSection.styles';

export const UnsupportedSection = () => <div data-testid="unsupportedSection" css={styles.outer} />;
